import { createContext } from 'react'
import type { StaffContextValue } from '@/types'

export const StaffContext = createContext<StaffContextValue | undefined>(
  undefined,
)
